import { z } from 'zod';
/** Permissions managed in the Novadan admin panel (design §7.2). */
export const Permission = {
    Access: 'novachat.access',
    ChannelsCreate: 'novachat.channels.create',
    Admin: 'novachat.admin',
};
export const PERMISSIONS = Object.values(Permission);
export const Platform = z.enum(['web', 'desktop', 'ios', 'android']);
const DeviceInfo = z.object({
    /** Shown in the session list, e.g. "MacBook Air · Chrome". */
    deviceName: z.string().trim().min(1).max(100),
    platform: Platform,
});
export const LoginRequest = DeviceInfo.extend({
    email: z.string().trim().min(1).max(254),
    password: z.string().min(1).max(512),
});
export const TwoFactorRequest = DeviceInfo.extend({
    challengeToken: z.string().min(1).max(2048),
    code: z.string().trim().regex(/^\d{4,8}$/),
});
export const TwoFactorResendRequest = z.object({
    challengeToken: z.string().min(1).max(2048),
});
/** Web clients send no body: their refresh token travels in an HttpOnly cookie. */
export const RefreshRequest = z
    .object({
    refreshToken: z.string().min(1).max(512).optional(),
})
    .default({});
//# sourceMappingURL=auth.js.map